import queryString from 'query-string'

const ensureValidProjectsQueryString = (filterOptionsFromEs) => {
  const VALID_ES_KEYS = [
    'architects',
    'arup_services',
    'country',
    'hall_uses',
    'in_outdoor',
    'project_types',
    'seat_count',
    'sort',
    'year',
  ]
  const search = window.location.search.replace('?', '')
  if (search === '') {
    return
  }
  const parsed = queryString.parse(search)
  const valid = {}
  Object.keys(parsed).forEach((esKey) => {
    if (VALID_ES_KEYS.indexOf(esKey) === -1) {
      return
    }
    valid[esKey] = []
    if (!Array.isArray(parsed[esKey])) {
      parsed[esKey] = [parsed[esKey]]
    }
    parsed[esKey].forEach((value) => {
      let low
      let high
      let valueComponents
      switch (esKey) {
        case 'architects':
        case 'arup_services':
        case 'country':
        case 'hall_uses':
        case 'in_outdoor':
        case 'project_types':
          if (filterOptionsFromEs[esKey].indexOf(value) !== -1) {
            valid[esKey].push(value)
          }
          break
        case 'seat_count':
          valueComponents = value.split('-')
          if (valueComponents.length === 2) {
            low = parseInt(valueComponents[0], 10)
            high = parseInt(valueComponents[1], 10)
            if (low === 0 && high === 1900 ||
                low === 200 && high === 299 ||
                low === 300 && high === 499 ||
                low === 500 && high === 999 ||
                low === 1000 && high === 1499 ||
                low === 1500 && high === 1999 ||
                low === 2000 && high === 3999 ||
                low === 4000 && high === 9999 ||
                low === 10000 && isNaN(high)) {
              if (isNaN(high)) {
                valid[esKey].push('10000-')
              }
              else {
                valid[esKey].push(`${low}-${high}`)
              }
            }
          }
          break
        case 'sort':
          if (['Newest first', 'Alphabetical'].indexOf(value) !== -1) {
            valid[esKey].push(value)
          }
          break
        case 'year':
          valueComponents = value.split('-')
          if (valueComponents.length === 2) {
            low = parseInt(valueComponents[0], 10)
            high = parseInt(valueComponents[1], 10)
            if (isNaN(low) && high === 1899 ||
                low === 1900 && high === 1949 ||
                low === 1950 && high === 1969 ||
                low === 1970 && high === 1989 ||
                low === 1990 && high === 1999 ||
                low === 2000 && high === 2009 ||
                low === 2010 && isNaN(high)) {
              if (isNaN(low)) {
                valid[esKey].push('-1899')
              }
              else if (isNaN(high)) {
                valid[esKey].push('2010-')
              }
              else {
                valid[esKey].push(`${low}-${high}`)
              }
            }
          }
          break
        default:
          break
      }
    })
  })
  const validSearch = queryString.stringify(valid)
  if (search !== validSearch) {
    window.location = `${window.location.pathname}?${validSearch}`
  }
}

export default ensureValidProjectsQueryString
